export default __webpack_public_path__ + "static/media/time.826a5379.svg";